export const pricingQueryKeys = {
  revenueCatOffering: (offering?: string) => ['revenue-cat-offering', offering] as const,
  revenueCatOfferings: () => ['revenue-cat-offerings'] as const,
  revenueCatCustomerInfo: () => ['revenue-cat-customer-info'] as const,

  managementUrl: () => ['pricing-managent-url'] as const,
};
